// usage like:
// >> import pricing from "@/pricing";
// >> pricing.deliverySubsidy("thai10_5");
// returns: 0.10

// const drivers = {
//     "@dev": "+662222226", // for staging local host
//     "@nick": "+66909588716",
// }

// Explanation of p_* billing
// p_x_y:
//          x% of order value goes to delivery fee (remained dropped if over delivery fee)
//          y% of order value is billed at end of month
//
// p_x:
//

const remitPrefix = "r_";

var pricing = {
  hasFreeDelivery(str) {
    if (!str) return false;
    // if (str.startsWith(remitPrefix)) {
    //   if (str.split(remitPrefix).length > 1) {
    //     return str.split(remitPrefix)[1].split("_") === 2;
    //   }
    //   return false;
    // }
    return (
      str.startsWith("p_") ||
      str.startsWith("f_") ||
      str.startsWith("thai") ||
      str.startsWith(remitPrefix)
    );
  },
  deliverySubsidy(str) {
    if (!str) return 0;
    // remit format: r_15_5
    // r_a_b means a% total, (a-b)% remit, b% delivery discount
    if (str.startsWith(remitPrefix) && str.split(remitPrefix).length > 1) {
      let arr = str.split(remitPrefix)[1].split("_");
      if (arr.length !== 2) return 0;
      return parseInt(arr[1]) / 100; // convert to percent
    }
    // new format: p_10_10
    if (str.startsWith("p_") && str.split("p_").length > 1) {
      let arr = str.split("p_")[1].split("_");
      return parseInt(arr[0]) / 100; // convert to percent
    }
    // another: f_10_10
    if (str.startsWith("f_") && str.split("f_").length > 1) {
      let arr = str.split("f_")[1].split("_");
      return parseInt(arr[0]) / 100; // convert to percent
    }
    // legacy format
    switch (str) {
      case "thai0":
      case "thai0_10":
      case "thai0_15":
      case "thai0_20":
      case "thai0_25":
        return 0;
      case "thai10": // case "thai010": // case "thai0_10":
      case "thai10_5":
      case "thai1010": // change existing in app to thai10_10
      case "thai10_10":
      case "thai10_0":
        return 0.1;
      case "thai15": // case "thai015": // case "thai0_15":
      case "thai15_5":
      case "thai15_10":
        return 0.15;
      case "thai20": // case "thai020": // case "thai0_20":
      case "thai20_0":
      case "thai20_5":
        return 0.2;
      case "thai25":
      case "thai25_0": // case "thai0_25":
        return 0.25;
      default:
        return 0;
    }
  },
  billing(str) {
    if (!str) return 0;
    // new format p_10_10
    if (str.startsWith("p_") && str.split("p_").length > 1) {
      var arr = str.split("p_")[1].split("_");
      if (arr.length === 2) {
        return parseInt(arr[1]) / 100; // convert to percent
      }
    }
    // another: f_10_10
    if (str.startsWith("f_") && str.split("f_").length > 1) {
      arr = str.split("f_")[1].split("_");
      if (arr.length === 2) {
        return parseInt(arr[1]) / 100; // convert to percent
      }
    }
    // legacy format
    if (str.startsWith("thai") && str.split("thai").length > 1) {
      arr = str.split("thai")[1].split("_");
      if (arr.length === 2) {
        return parseInt(arr[1]) / 100; // convert to percent
      }
    }
    return 0;
  },
  remit(str) {
    if (!str) return 0;
    // format r_15_5 = 1st number is remit percent, 2nd is delivery subsidy percent
    if (str.startsWith(remitPrefix) && str.split(remitPrefix).length > 1) {
      var arr = str.split(remitPrefix)[1].split("_");
      return parseInt(arr[0]) / 100; // convert to percent
    }
    return 0;
  },
};

export default pricing;
